import * as React from 'react';
import withStyles, { WithStyles, StyleRules, ClassNameMap } from '@material-ui/core/styles/withStyles';
import { Switch, Route } from 'react-router-dom';
import { Theme } from '@material-ui/core/styles';
import AppView from '~common/components/app-view/index';
import FormBasedEditor from '~common/form/form-based-editor';
import ChangePassword from '~auth/components/reset-change-password';
import PortalUserContext, { UserType } from '../../../../../common/ui/lib/portal-user-context';
import * as request from 'superagent';
import URLManager from '~common/lib/url-manager';



const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
	}
});

interface Props extends React.HTMLProps<HTMLDivElement> {
	history: any;
  	match: any;
}

type State = {
	// status: "loading" | "ready"
	// form: any;
	// data: any;
};

class Preferences extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {
			// form: {},
			// data: {},
		};
	}

	// componentDidMount() {
	// 	var {id} = this.props.match.params
		
	// 	var hasPortalUserLogin = false
	// 	if (PortalUserContext.userContext && PortalUserContext.userContext.extendedAttributes && PortalUserContext.userContext.extendedAttributes.hasPortalUserLogin) {
	// 		hasPortalUserLogin = true
	// 	}

	// 	var promises: Array<any> = [
	// 		request.get(
	// 		  '/api/form-definitions/select?selector='+URLManager.getQueryStringValue({"form": "userPreferences", "modules": "users", "userType": PortalUserContext.userContext.userType == 'Vendor' ? 'Vendor' : "Any", hasPortalUserLogin: hasPortalUserLogin ? "Yes" : "No"})),
	// 		  request.get("/api/portal-users/preferences" + '/' + "undefined")
	// 	];
	// 	Promise.all(promises).then((values: Array<request.Response>)=>{
	// 		console.log("values", values)
	// 	}).catch((err)=>{
	// 		console.log("err", err)
	// 		// const apiErr = new APIError()
    //         // apiErr.type = "http"
	// 		// apiErr.message = (err.response || { text: err.toString() }).text
	// 		// this.setState({
	// 		// 	error: apiErr
	// 		// })
	// 	})
	// }

	componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {}

	render() {
		const { classes }: { classes: ClassNameMap } = this.props;

		var selector = {"formType":"userPreferences", "form": "userPreferences", "modules": "users", "userType": PortalUserContext.userContext.userType == 'Vendor' ? 'Vendor' : "Any"}
		if (!PortalUserContext.userContext.extendedAttributes.hasPortalUserLogin) {
			selector["nonSSO"] = "true"
		} else {
			selector["nonSSO"] = "false"
		}

		return (
			<div className={classes.container}>
				<AppView history={this.props.history}>
				<FormBasedEditor 
					history={this.props.history} 
					match={this.props.match}
					dataUrl="/api/portal-users/preferences"
					formSelector={selector}
				>
				</FormBasedEditor>
				</AppView>
			</div>
		);
	}
}

export default withStyles(styles)(Preferences);


